// @ts-strict-ignore
import type { Ref } from 'vue'
import type { Pagination, Sort, ToolingPagination } from '../../models'
import type { ToolingPaginationComposable, ToolingPaginationComposableParams } from './types'
import { getCurrentInstance, ref } from 'vue'
import { SortDirectionEnum } from '../../enums'
import { TOOLING_CONSTS } from '../../store/tooling/tooling.consts'
import { mapActions, mapGetters } from '../utils'

const defaultItemsPerPageOptions = [10, 20, 50]

export function useToolingPagination(
  options?: ToolingPaginationComposableParams,
): ToolingPaginationComposable {
  const {
    proxy: { $store },
  } = getCurrentInstance()

  const { toolsPagination } = mapGetters<ToolingPagination>($store, TOOLING_CONSTS.moduleName, {
    toolsPagination: TOOLING_CONSTS.getters.pagination,
  })

  const itemsPerPageOptions = options?.itemsPerPageOptions ?? defaultItemsPerPageOptions

  let itemsPerPage = itemsPerPageOptions[0]

  if (toolsPagination.value.itemsPerPage !== 0) {
    itemsPerPage = toolsPagination.value.itemsPerPage
  }

  const pagination: Ref<Pagination> = ref({
    page: 1,
    itemsPerPage,
    totalItems: 0,
  })

  const toolingStore = mapActions($store, TOOLING_CONSTS.moduleName, {
    setPagination: TOOLING_CONSTS.actions.setPagination,
  })

  const setToolingPagination = (newPagination: Pagination): void => {
    pagination.value = { ...pagination.value, ...newPagination }

    toolingStore.setPagination({ itemsPerPage: newPagination.itemsPerPage })
  }

  const resetPage = (): void => {
    pagination.value.page = 1
  }

  const setToolingPaginationBasedOnSort = (sort: Sort): void => {
    const dateSortFields = ['updated', 'updated_on']
    if (dateSortFields.includes(sort.field)) {
      if (sort.direction === SortDirectionEnum.DESCENDING) {
        resetPage()
      } else if (sort.direction === SortDirectionEnum.ASCENDING) {
        const lastPage = Math.ceil(pagination?.value.totalItems / pagination?.value.itemsPerPage)
        pagination.value.page = lastPage
      }
    }
  }

  return {
    pagination,
    itemsPerPageOptions,
    setToolingPagination,
    resetPage,
    setToolingPaginationBasedOnSort,
  }
}
